"use client";

import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import Link from "next/link";
import Image from "next/image";
import ServiceindividualCards from "../individual-saving/page";

const services = [
  {
    title: "Individual Savings Solutions",
    image: "/projects/profile.jpg",
    description:
      "Personalized savings plans designed to help individuals build financial security and achieve their goals.",
    lists: [
      "Regular savings accounts",
      "Fixed deposit options",
      "Automatic savings plans",
    ],
    details:
      "Our savings solutions offer flexible deposit options, competitive interest rates, and easy access to your funds to support your financial growth and stability.",
  },
  {
    title: "Institutional Savings",
    image: "/projects/profile2.jpg",
    description:
      "Savings solutions tailored for organizations and institutions to manage funds effectively.",
    lists: [
      "Corporate savings accounts",
      "Reserve fund management",
      "Custom deposit schemes",
    ],
    details:
      "We provide flexible savings products with competitive rates and tailored features to help institutions maximize fund growth and liquidity management.",
  },
];

const otheryegna = [
  {
    title: "Special Property Loan",
    description:
      "This loan is designed for employees of YMFI's strategic partners, offering a lower interest rate than conventional fixed asset loans. Loan terms range from 12 to 60 months, with monthly or quarterly repayments.",
    image: "/projects/etege1.png",
  },
  {
    title: "Agriculture Loan",
    description:
      "This loan will be availed to middle income farmer borrowers for purchasing agricultural inputs: like fertilizer, improved seed, land rent, purchase of oxen and for fattening activities.",
    image: "/projects/etege.png",
  },
  {
    title: "Special Emergency Loan",
    description:
      "This short-term credit is designed for businesses needing urgent financing, such as importers and contractors. Loans must be repaid within six months, with flexible repayment options: monthly, quarterly, or lump sum at maturity. It supports businesses with immediate financial needs and quick returns.",
    image: "/projects/profile3.jpg",
  },
  {
    title: "Urban Agriculture and Innovation Loan",
    description:
      "This loan supports agricultural activities in urban areas, including oxen, poultry, dairy, fattening, animal husbandry, irrigation, land rent, handicrafts, and beekeeping. The loan term ranges from 12 to 36 months, catering to small-scale farmers and agribusinesses.",
    image: "/projects/profile3.jpg",
  },
];

const projects = [
  {
    title: "Organizational/ Institutional Saving Accounts",
    description:
      "Account opened for formal organizations, institutions, clubs, associations, union, etc with very attractive interest rate.It bears minimum interest rate of 9.25% per annum.",
    image: "/projects/organization.jpg",
  },
  {
    title: "Ikub Saving Account",
    description:
      "Account dedicated as an adaptation of the traditional money saving experience (Ikub) in to modern microfinancing system to enable easy collection of funds with attractive value prepositions to members and leaders.The account has three types: Large, Medium and Small,It bears very attractive interest rate ranging from 11% to 12% per annum,Member and leader get credit faciltity from Yegna MFI at very minimal loan interest rate,Other value prepositions/ benefit attached to the account.",
    image: "/projects/ekub.jpg",
  },
  {
    title: "Idir Saving Account",
    description:
      "Account dedicated for Idir associations to assist them with attractive interest rate and other value prepositions.It bears annual interest rate of 10.5% per annum,Overdraft loan facility attached to the account,Member and leader get affordable credit facility with very minimal loan interest rate,Other attractive value prepositions attached to the account.",
    image: "/projects/smallbuisness2.jpg",
  },

  {
    title: "Investment Saving Account (እድገት የቁጠባ ሂሳብ)",
    description:
      "The Investment Saving Account (እድገት የቁጠባ ሂሳብ) is a premium savings product designed for customers seeking higher returns, flexibility, and secure long-term savings. It helps Yegna MFI mobilize stable deposits, expand its customer base, and strengthen its lending capacity while providing attractive benefits to customers.",
    image: "/projects/investment.png",
  },


  {
    title: "Elders Saving Account (ክብር የቁጠባ ሂሳብ)",
    description:
      "The Elders Saving Account (ክብር የቁጠባ ሂሳብ) is a specialized savings product designed for senior citizens aged 54 and above, providing a safe, rewarding, and accessible way to save. It aims to promote financial independence while helping Yegna MFI attract stable deposits, expand its customer base, and strengthen financial inclusion.",
    image: "/projects/kibr1.png",
  },


  {
    title: "Commitment Saving Account",
    description:
      "Account opened to eligible customer in order to get credit facility on save and borrow principles.Loan attached to the account for purchase of Vehicles, house, household appliances, Consumer goods, school/college fees, for business start-ups, working capital, personal consumptions, purchase of other fixed asset, etc.Saving Modality: 20/80, 30/70, 40/60 and 50/50 for the minimum of 5 months with different saving options: in advance, equal monthly and other options.The account bears attractive interest rate of 9.25% per annum.",
    image: "/projects/commitments.jpg",
  },
  {
    title: "Time Deposit",
    description:
      "Account opened for natural and legal persons with formal contractual agreement to deposit money for specified period with attractive negotiable interest rate.The minimum interest rate is 16.5% per annum and increase with the amount of deposit and duration of period (lock-in period).There are options on saving model with flexible saving option to increase principal at regular or irregular interval of periods.",
    image: "/projects/time deposit.jpg",
  },
  {
    title: "EV Battery Replacement Saving",
    description:
      "Account opened to any eligible customer who want to save for the sake of replacement of EV-Battery  and get loan attached to the account for EV-Battery replacement. 200% loan in excess of saving will be provided for clients for replacement of EV-Battery. The account gets annual interest rate of 10.5%.",
    image: "/projects/evbattry.jpg",
  },
  {
    title: "Normal Compulsory Saving",
    description:
      "Account opened for loan clients for saving upfront and ongoing compulsory saving as a pre-requirement to get loan facility from Yegna MFI.The account gets annual interest rate of 7%.",
    image: "/projects/count3.jpg",
  },
];

// Clean color palette - Only Deep Teal Green and White
const colors = {
  primary: "#395750",      // Deep Teal Green - Company color
  primaryDark: "#2A423C",  // Darker teal
  primaryLight: "#4B6B63", // Lighter teal
  white: "#FFFFFF",        // White
  whiteOff: "#F8F9FA",     // Off-white for subtle contrast
  textDark: "#1A2E29",     // Dark text for contrast
};

const text = "Details of Our Services";

export default function ServiceCards() {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (currentIndex < text.length) {
      const timeout = setTimeout(() => {
        setCurrentIndex((prev) => prev + 1);
      }, 100);
      return () => clearTimeout(timeout);
    }
  }, [currentIndex]);

  return (
    <div className="mt-30 mb-20 space-y-16 pt-28 overflow-x-hidden sm:pt-10 md:pt-6 lg:pt-0">
      {/* Animated Background Section */}
      <div className="relative w-full overflow-hidden py-24 md:py-32" style={{ background: `linear-gradient(135deg, ${colors.primary}, ${colors.primaryDark})` }}>
        {/* Subtle pattern overlay */}
        <div className="absolute inset-0 opacity-10">
          <svg
            className="h-full w-full"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 100 100"
            preserveAspectRatio="none"
          >
            <path
              d="M0,0 L100,0 L100,100 L0,100 Z"
              fill="none"
              stroke={colors.white}
              strokeWidth="0.5"
              strokeDasharray="2 2"
            />
          </svg>
        </div>

        {/* Content container */}
        <div className="container relative mx-auto px-6">
          <h1 className="text-center font-orbitron text-4xl font-bold text-white sm:text-5xl md:text-6xl lg:text-7xl">
            <span className="relative inline-block">
              {text.substring(0, currentIndex)}
              <motion.span
                className="absolute -right-3 top-0 h-12 w-1 bg-white"
                initial={{ opacity: 0 }}
                animate={{
                  opacity: [0, 1, 0],
                  scaleY: [1, 1.2, 1],
                }}
                transition={{
                  repeat: Infinity,
                  duration: 0.8,
                  ease: "easeInOut",
                }}
              />
            </span>
          </h1>

          {/* Decorative elements */}
          <div className="mt-12 flex justify-center space-x-4">
            {[1, 2, 3].map((item) => (
              <motion.div
                key={item}
                className="h-2 rounded-full bg-white/30"
                initial={{ width: 0 }}
                animate={{ width: item % 2 === 0 ? "40px" : "20px" }}
                transition={{
                  duration: 0.6,
                  delay: item * 0.2,
                  repeat: Infinity,
                  repeatType: "reverse",
                }}
              />
            ))}
          </div>
        </div>

        {/* Wave divider at bottom */}
        <div className="absolute bottom-0 left-0 right-0 h-12 overflow-hidden">
          <svg
            viewBox="0 0 1200 120"
            preserveAspectRatio="none"
            className="h-full w-full"
          >
            <path
              d="M0,0V46.29c47.79,22.2,103.59,32.17,158,28,70.36-5.37,136.33-33.31,206.8-37.5C438.64,32.43,512.34,53.67,583,72.05c69.27,18,138.3,24.88,209.4,13.08,36.15-6,69.85-17.84,104.45-29.34C989.49,25,1113-14.29,1200,52.47V0Z"
              opacity=".25"
              fill={colors.white}
            ></path>
            <path
              d="M0,0V15.81C13,36.92,27.64,56.86,47.69,72.05,99.41,111.27,165,111,224.58,91.58c31.15-10.15,60.09-26.07,89.67-39.8,40.92-19,84.73-46,130.83-49.67,36.26-2.85,70.9,9.42,98.6,31.56,31.77,25.39,62.32,62,103.63,73,40.44,10.79,81.35-6.69,119.13-24.28s75.16-39,116.92-43.05c59.73-5.85,113.28,22.88,168.9,38.84,30.2,8.66,59,6.17,87.09-7.5,22.43-10.89,48-26.93,60.65-49.24V0Z"
              opacity=".5"
              fill={colors.white}
            ></path>
            <path
              d="M0,0V5.63C149.93,59,314.09,71.32,475.83,42.57c43-7.64,84.23-20.12,127.61-26.46,59-8.63,112.48,12.24,165.56,35.4C827.93,77.22,886,95.24,951.2,90c86.53-7,172.46-45.71,248.8-84.81V0Z"
              fill={colors.white}
            ></path>
          </svg>
        </div>
      </div>

      {/* Projects Section */}
      <div className="mt-20 px-4 lg:mx-auto lg:max-w-[1500px]" id="projects">
        <div className="py-3" style={{ background: `linear-gradient(135deg, ${colors.white}, ${colors.primary}05)` }}>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="mb-16 text-center text-4xl font-bold sm:text-5xl"
            style={{ color: colors.primary }}
          >
            <span className="relative inline-block">
              <span className="bg-gradient-to-r bg-clip-text text-transparent" style={{ backgroundImage: `linear-gradient(to right, ${colors.primary}, ${colors.primaryLight})` }}>
                Saving Products
              </span>
              <motion.span
                className="absolute bottom-0 left-1/2 h-1 w-24 -translate-x-1/2 transform bg-gradient-to-r"
                style={{ background: `linear-gradient(to right, ${colors.primary}, ${colors.primaryLight})` }}
                initial={{ scaleX: 0 }}
                animate={{ scaleX: 1 }}
                transition={{ duration: 0.8, delay: 0.3 }}
              />
            </span>
          </motion.h2>
          
          <ServiceindividualCards />

          <div className="relative">
            {/* Timeline connector */}
            <div className="absolute left-1/2 top-0 hidden h-full w-0.5 -translate-x-1/2 transform md:block" style={{ background: `linear-gradient(to bottom, transparent, ${colors.primary}, transparent)` }}></div>

            <div className="space-y-32">
              {projects.map((project, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0 }}
                  whileInView={{ opacity: 1 }}
                  viewport={{ once: true, margin: "-100px" }}
                  transition={{ duration: 0.6, delay: index * 0.1 }}
                  className="relative z-10"
                >
                  {/* Timeline dot */}
                  <div className="absolute left-1/2 top-0 z-10 h-6 w-6 -translate-x-1/2 transform rounded-full shadow-md md:top-1/4" style={{ background: `linear-gradient(135deg, ${colors.primary}, ${colors.primaryLight})` }}></div>

                  <div className={`flex flex-col ${index % 2 ? 'md:flex-row-reverse' : 'md:flex-row'} items-stretch gap-8 md:gap-12`}>
                    {/* Image - Wide format */}
                    <motion.div
                      className="md:w-3/5"
                      initial={{ x: index % 2 ? 100 : -100, opacity: 0 }}
                      whileInView={{ x: 0, opacity: 1 }}
                      transition={{ duration: 0.6 }}
                    >
                      <div className="relative aspect-[16/6] overflow-hidden rounded-xl shadow-2xl" style={{ border: `4px solid ${colors.white}` }}>
                        <Image
                          src={project.image}
                          alt={project.title}
                          fill
                          className="object-cover transition-transform duration-500 hover:scale-105"
                        />
                        <div className="absolute inset-0" style={{ background: `linear-gradient(to right, ${colors.primary}30, transparent)` }}></div>
                      </div>
                    </motion.div>

                    {/* Content - Corporate style panel */}
                    <motion.div
                      className="md:w-2/5"
                      initial={{ x: index % 2 ? -50 : 50, opacity: 0 }}
                      whileInView={{ x: 0, opacity: 1 }}
                      transition={{ duration: 0.6, delay: 0.2 }}
                    >
                      <div className={`h-full ${index % 2 ? 'md:pl-8' : 'md:pr-8'} flex flex-col justify-center`}>
                        <motion.div
                          className="mb-6 flex items-start"
                          initial={{ opacity: 0 }}
                          whileInView={{ opacity: 1 }}
                          transition={{ delay: 0.3 }}
                        >
                          <div className="mr-4 h-12 w-1" style={{ background: `linear-gradient(to bottom, ${colors.primary}, ${colors.primaryLight})` }}></div>
                          <div>
                            <motion.h3
                              className="text-3xl font-bold"
                              style={{ color: colors.primary }}
                              initial={{ opacity: 0 }}
                              whileInView={{ opacity: 1 }}
                              transition={{ delay: 0.4 }}
                            >
                              {project.title}
                            </motion.h3>
                            <motion.div
                              className="mt-3 h-1 w-16"
                              style={{ background: `linear-gradient(to right, ${colors.primary}, ${colors.primaryLight})` }}
                              initial={{ scaleX: 0 }}
                              whileInView={{ scaleX: 1 }}
                              transition={{ delay: 0.5 }}
                            />
                          </div>
                        </motion.div>

                        <motion.p
                          className="mb-8 text-lg"
                          style={{ color: colors.textDark }}
                          initial={{ opacity: 0 }}
                          whileInView={{ opacity: 1 }}
                          transition={{ delay: 0.6 }}
                        >
                          {project.description}
                        </motion.p>
                      </div>
                    </motion.div>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}